const regexp = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;

export function validateIsHexColor (str: string) {
    return regexp.test(str)
}